import * as Sentry from '@sentry/capacitor';

export const semverToInteger = (version: string): number => {
  try {
    const versionWithoutLetters = version.replace(/[^0-9.]/g, '');
    const stringParts = versionWithoutLetters
      .split('.')
      .map((part) => part.padStart(2, '0'));

    return Number(stringParts.join(''));
  } catch (err) {
    Sentry.setContext('failed-to-convert-app-version-to-integer', { version });
    Sentry.captureException(err);
  }

  return 0;
};
